import React from 'react'
import { Modal, Button, Text, Box, Flex } from '@mantine/core'

const ModalConfirm = ({ isOpen, onClose, item, remove }) =>
{
  const close = () =>
  {
    onClose()
  }

  return (
    <>
      <Modal 
        opened={ isOpen } 
        onClose={ close } 
        title="Confirmar Eliminación" 
        centered
        radius="lg"
      >
        <Box p="md">
          <Text size="sm" mb="lg">
            ¿Estás seguro que deseas eliminar a <b>{ item?.full_name }</b>? Esta acción no se puede deshacer.
          </Text>

          <Flex gap="md" mt="xl">
            <Button fullWidth color='gray' variant='light' onClick={ close }>
              Cancelar
            </Button>
            <Button fullWidth onClick={ () => remove({ _id: item._id }) }>
              Confirmar
            </Button>
          </Flex>
        </Box>
      </Modal>
    </>
  )
}

export default ModalConfirm
